import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import * as i3 from '@engineering11/ui-lib/e11-directives';
import { E11SummernoteViewDirective } from '@engineering11/ui-lib/e11-directives';
import { NgxSummernoteModule } from 'ngx-summernote';

class E11ReadMoreComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.expandText = 'Read More';
        this.collapseText = 'Show Less';
        this.fontSize = 'sm';
        this.buttonPosition = 'left';
        this.characterLimit = 100;
        this.showButton = true;
        this.buttonTextColor = 'primary';
        this.isSummerNoteContent = false;
        this.isExpanded = false;
    }
    ngOnInit() {
        this.truncate();
    }
    truncate() {
        if (!this.content) {
            return;
        }
        const truncatedContent = this.truncateContent();
        this._content = this.isSummerNoteContent ? truncatedContent : this.sanitizer.bypassSecurityTrustHtml(truncatedContent);
    }
    get isTruncated() {
        return this.content?.length > this.characterLimit;
    }
    truncateContent() {
        let value = '';
        if (this.content.length <= this.characterLimit) {
            value = this.content;
        }
        else {
            value = this.content.slice(0, this.characterLimit) + '...';
        }
        return value;
    }
    toggleExpansionState() {
        if (!this.isTruncated) {
            return;
        }
        this.isExpanded = !this.isExpanded;
        if (!this.isExpanded) {
            this.truncate();
            return;
        }
        this._content = this.content;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreComponent, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11ReadMoreComponent, selector: "e11-read-more", inputs: { expandText: "expandText", collapseText: "collapseText", fontSize: "fontSize", buttonPosition: "buttonPosition", characterLimit: "characterLimit", showButton: "showButton", buttonTextColor: "buttonTextColor", buttonClassOverrides: "buttonClassOverrides", isSummerNoteContent: "isSummerNoteContent", content: "content" }, ngImport: i0, template: "<div class=\"e11-read-more\">\n  <div [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\">\n    <ng-container *ngIf=\"!isSummerNoteContent; else summerNote\">\n      <div class=\"e11-read-more-content\" [innerHTML]=\"_content\"></div>\n    </ng-container>\n\n    <ng-template #summerNote>\n      <div [e11SummernoteView]=\"$any(_content)\"></div>\n    </ng-template>\n  </div>\n\n  <div\n    *ngIf=\"showButton\"\n    [ngClass]=\"{ 'e11-justify-start': buttonPosition === 'left', 'e11-justify-end': buttonPosition === 'right' }\"\n    class=\"e11-mt-3 e11-flex e11-justify-content-end\"\n  >\n    <button\n      (click)=\"toggleExpansionState()\"\n      *ngIf=\"isTruncated && !isExpanded\"\n      [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\"\n      class=\"e11-flex e11-items-center e11-read-more-{{ buttonTextColor }} {{ buttonClassOverrides }}\"\n    >\n      {{ expandText }}\n      <span class=\"material-icons e11-ml-2\"> expand_more </span>\n    </button>\n\n    <button\n      (click)=\"toggleExpansionState()\"\n      *ngIf=\"isExpanded\"\n      [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\"\n      class=\"e11-flex e11-items-center e11-read-more-{{ buttonTextColor }} {{ buttonClassOverrides }}\"\n    >\n      {{ collapseText }}\n      <span class=\"material-icons e11-ml-2\"> expand_less </span>\n    </button>\n  </div>\n</div>\n", styles: [".e11-read-more .e11-read-more-content p{display:inline}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.E11SummernoteViewDirective, selector: "[e11SummernoteView]", inputs: ["e11SummernoteView"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-read-more', encapsulation: ViewEncapsulation.None, template: "<div class=\"e11-read-more\">\n  <div [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\">\n    <ng-container *ngIf=\"!isSummerNoteContent; else summerNote\">\n      <div class=\"e11-read-more-content\" [innerHTML]=\"_content\"></div>\n    </ng-container>\n\n    <ng-template #summerNote>\n      <div [e11SummernoteView]=\"$any(_content)\"></div>\n    </ng-template>\n  </div>\n\n  <div\n    *ngIf=\"showButton\"\n    [ngClass]=\"{ 'e11-justify-start': buttonPosition === 'left', 'e11-justify-end': buttonPosition === 'right' }\"\n    class=\"e11-mt-3 e11-flex e11-justify-content-end\"\n  >\n    <button\n      (click)=\"toggleExpansionState()\"\n      *ngIf=\"isTruncated && !isExpanded\"\n      [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\"\n      class=\"e11-flex e11-items-center e11-read-more-{{ buttonTextColor }} {{ buttonClassOverrides }}\"\n    >\n      {{ expandText }}\n      <span class=\"material-icons e11-ml-2\"> expand_more </span>\n    </button>\n\n    <button\n      (click)=\"toggleExpansionState()\"\n      *ngIf=\"isExpanded\"\n      [ngClass]=\"{ 'e11-text-sm': fontSize === 'sm', 'e11-text-md': fontSize === 'md', 'e11-text-lg': fontSize === 'lg' }\"\n      class=\"e11-flex e11-items-center e11-read-more-{{ buttonTextColor }} {{ buttonClassOverrides }}\"\n    >\n      {{ collapseText }}\n      <span class=\"material-icons e11-ml-2\"> expand_less </span>\n    </button>\n  </div>\n</div>\n", styles: [".e11-read-more .e11-read-more-content p{display:inline}\n"] }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }], propDecorators: { expandText: [{
                type: Input
            }], collapseText: [{
                type: Input
            }], fontSize: [{
                type: Input
            }], buttonPosition: [{
                type: Input
            }], characterLimit: [{
                type: Input
            }], showButton: [{
                type: Input
            }], buttonTextColor: [{
                type: Input
            }], buttonClassOverrides: [{
                type: Input
            }], isSummerNoteContent: [{
                type: Input
            }], content: [{
                type: Input
            }] } });

class E11ReadMoreModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreModule, declarations: [E11ReadMoreComponent], imports: [CommonModule, NgxSummernoteModule, E11SummernoteViewDirective], exports: [E11ReadMoreComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreModule, imports: [CommonModule, NgxSummernoteModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ReadMoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11ReadMoreComponent],
                    imports: [CommonModule, NgxSummernoteModule, E11SummernoteViewDirective],
                    exports: [E11ReadMoreComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11ReadMoreComponent, E11ReadMoreModule };
